export const environment = {
  production: true,
  buildId: '3938716059923941',
  configFile: 'config.json',
};
